export default __webpack_public_path__ + "static/media/vanessa.6c398878.png";